// extracted by mini-css-extract-plugin
export default {"container":"TopicDescription_container__ReJ3M","title":"TopicDescription_title__yo05r","description":"TopicDescription_description__qHKym"};